import React from "react"
import PropTypes from "prop-types"

import styles from "./TextInput.module.css"

const inputTypes = {
  text: "text",
  number: "number",
}

const TextInput = props => (
  <input
    className={
      props.type === inputTypes.number ? styles.inputSmall : styles.input
    }
    max={props.max}
    min={props.min}
    name={props.name}
    placeholder={props.placeholder}
    type={props.type}
    value={props.value}
    required={props.required}
    id={props.id}
  />
)

TextInput.propTypes = {
  type: PropTypes.oneOf([inputTypes.text, inputTypes.number]),
  max: PropTypes.string,
  min: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default TextInput
